import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {AppError, AppInfo} from '../interfaces/app-error';
import {MatSidenav} from '@angular/material/sidenav';



@Injectable({providedIn: 'root'})
export class  AppStateService {
i
    public sidenav: MatSidenav;

    private errorStatus = new BehaviorSubject<AppError>(null);
    public errorStatus$ = this.errorStatus.asObservable();

    constructor() {
    }

    public confirmDialog = (data: any): Promise<any> => Promise.resolve(); // Function

    public infoDialog = (data: any): Promise<any> => Promise.resolve(); // Function

    public toggleSideBar() {

        if (this.sidenav) {
            console.log('Toggle sidebar invoked. Current status: ', this.sidenav.opened);
            return this.sidenav.toggle();
        } else {
            console.log('Sidenav toggle fired but is undefined..');
        }
    }

    public showError(newError: AppError) {
        this.errorStatus.next(newError);
    }

}
